var _style, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 28 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st2{fill:#a5abaf}.st4{fill:#fff}")), /*#__PURE__*/React.createElement("g", {
    id: "Web-_x2014_-Docs-_x2014_-User-Guide-_x2014_-GeoTrax-Web-_x28_Scroll_x29_",
    transform: "translate(-546 -570)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1_",
    transform: "translate(493 -140)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(38 702)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User-Guide-Document-Menu-Item"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PDF-Icon",
    transform: "translate(15 8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pdf-_x28_1_x29_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M6 0C4.9 0 4 .9 4 2v28c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2V8l-8-8z",
    style: {
      fill: "#c8cdd0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1_",
    d: "M22 8h6l-8-8v6c0 1.1.9 2 2 2",
    style: {
      fill: "#878e93"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2_",
    d: "m28 14-6-6h6z",
    className: "st2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3_",
    d: "M24 26c0 .5-.5 1-1 1H1c-.6 0-1-.5-1-1V15.6c0-.6.4-1 1-1h22c.5 0 1 .4 1 1z",
    style: {
      fill: "#f66a00"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5_",
    d: "M23 27H4v1h19c.5 0 1-.5 1-1v-1c0 .5-.5 1-1 1",
    className: "st2"
  })))))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(4.313 18.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M-1.3-.2c0-.3.2-.6.6-.6h2.1c1.2 0 2.3.8 2.3 2.3S2.6 3.8 1.4 3.8H-.1V5c0 .4-.3.6-.6.6s-.6-.2-.6-.6zm1.2.5v2.3h1.5c.6 0 1.1-.5 1.1-1.1S2 .3 1.4.3z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_",
    d: "M5.6 5.6c-.3 0-.6-.2-.6-.6V-.3c0-.3.3-.6.6-.6h2.1c4.2 0 4.1 6.4.1 6.4H5.6zM6.2.4v4.1h1.5c2.5 0 2.6-4.1 0-4.1z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4_",
    d: "M13.3.4v1.5h2.4c.3 0 .7.3.7.7 0 .3-.3.6-.7.6h-2.4v1.9c0 .3-.2.6-.6.6s-.7-.2-.7-.6V-.2c0-.3.3-.6.7-.6H16q.6 0 .6.6c0 .3-.2.6-.6.6z",
    className: "st4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdfIcon.0bd951f361821eb1098553e2f3fb35f0.svg";
export { ForwardRef as ReactComponent };